import { render } from "./ExampleError.vue?vue&type=template&id=768bc860"
import script from "./js/exampleError.js?vue&type=script&lang=js&external"
export * from "./js/exampleError.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__